import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useCopyTimeLineMutation, useDeleteTimeLineMutation } from '@redux/api/timeline.api'

import { ROUTES } from '@constants'
import { CopyModelDataType, DataOfCopiedModelType } from '@types'

export const useHandlers = ({ refetchAllTimeLines }) => {
  const navigate = useNavigate()

  const [showCopyDialog, setShowCopyDialog] = useState(false)
  const [deleteId, setDeleteId] = useState<number>()
  const [copyData, setCopyData] = useState<DataOfCopiedModelType>()

  const [copyTimeLine, { isLoading: isLoadingCopy }] = useCopyTimeLineMutation()
  const [deleteTimeLine, { isLoading: isLoadingDelete }] = useDeleteTimeLineMutation()

  const handleClickCreateTimeLine = () => {
    navigate(ROUTES.TIME_LINE_GRID_CREATE)
  }
  const handleEditTimeLine = (id: number) => {
    navigate(ROUTES.TIME_LINE_GRID_EDIT + `/${id}`)
  }
  const handleShowCopyDialog = (id: number, title: string) => {
    setShowCopyDialog(true)
    setCopyData({
      id,
      title,
    })
  }

  useEffect(() => {
    refetchAllTimeLines()
  }, [])

  const handleCloseCopyDialog = () => {
    setShowCopyDialog(false)
  }
  const handleCopyTimeLine = (data: CopyModelDataType) => {
    copyTimeLine({
      id: data.copyId,
      code: data.code,
      title: data.title,
    }).then(() => {
      refetchAllTimeLines()
      handleCloseCopyDialog()
    })
  }

  const handleShowDeleteModal = (id: number) => {
    setDeleteId(id)
  }

  const handleCloseDeleteModal = () => {
    setDeleteId(undefined)
  }

  const handleDeleteTimeLine = () => {
    if (deleteId) {
      deleteTimeLine(deleteId).then(() => {
        refetchAllTimeLines()
      })
    }
    handleCloseDeleteModal()
  }

  return {
    state: {
      isLoadingCopy,
      isLoadingDelete,
      showCopyDialog,
      showDeleteModal: Boolean(deleteId),
      copyData,
    },
    handlers: {
      handleClickCreateTimeLine,
      handleEditTimeLine,
      handleShowCopyDialog,
      handleShowDeleteModal,
      handleCloseCopyDialog,
      handleCopyTimeLine,
      handleCloseDeleteModal,
      handleDeleteTimeLine,
    },
  }
}
